import { setup } from 'xstate';

export const flowMachine = setup({}).createMachine({
  id: 'doubt-atlas-flow',
  initial: 'booting',
  states: {
    booting: { on: { READY: 'loadingDilemma', ERROR: 'error' } },
    loadingDilemma: { on: { LOADED: 'playing', ERROR: 'error' } },
    playing: { on: { SUBMIT: 'submitting', SKIP: 'loadingDilemma' } },
    submitting: { on: { SAVED: 'mirroring', ERROR: 'error' } },
    mirroring: { on: { NEXT: 'loadingDilemma', VIEW_ATLAS: 'viewingAtlas' } },
    viewingAtlas: { on: { PLAY: 'loadingDilemma', REFRESH: 'viewingAtlas' } },
    error: { on: { RETRY: 'loadingDilemma' } }
  }
});
